import { selectCurrentUser } from '~/redux/slices/user'
import { useAppSelector } from '~/redux/hooks'
import { IUser } from '~/types/user-info-types'

const useCurrentUser = (): IUser | null => {
  const user = useAppSelector(selectCurrentUser)
  return user
}

export default useCurrentUser
